/**
 * Promise state
 */
export enum PromiseState {
  Pending,
  Fulfilled,
  Rejected
}


/**
 * Promise wrapper that allows synchronous introspection of the promise's state.
 */
export class StatefulPromise<T> {
  value: T;
  reason: any;
  state: PromiseState = PromiseState.Pending;

  constructor(public promise: Promise<T>) {
    promise.then((value: T) => {
      this.value = value;
      this.state = PromiseState.Fulfilled;
    }, reason => {
      this.reason = reason;
      this.state = PromiseState.Rejected;
    });
  }
}
